module.exports = __webpack_public_path__ + "static/media/PDFImage.8a1c0bf3.svg";